module.exports = __webpack_public_path__ + "img/202412_firstserum.eb17ee8f.jpg";